module.exports = __webpack_public_path__ + "img/icon02.9acf98e0.png";